var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("api-errors", { attrs: { errors: _vm.issuesErrors } }),
      _vm._v(" "),
      _c("div", { staticClass: "panel panel-default" }, [
        _c("div", { staticClass: "panel-heading" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Search all issues" },
                  domProps: { value: _vm.search },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.triggerSearchButton.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.search = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-btn" }, [
                  _c(
                    "a",
                    {
                      ref: "searchButton",
                      staticClass: "btn btn-default color-black",
                      attrs: { href: _vm.generateUrl("search", _vm.search) },
                    },
                    [
                      _vm._v("\n                                Search "),
                      _c("i", {
                        staticClass: "fa fa-search",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("div", { staticClass: "btn-group" }, [
                _vm.itemId
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success dropdown-toggle",
                        attrs: {
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false",
                        },
                      },
                      [
                        _vm._v("\n                        New Issue  "),
                        _c("span", { staticClass: "caret" }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("ul", { staticClass: "dropdown-menu" }, [
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: { click: _vm.openIssuesModal },
                      },
                      [_vm._v("New Issue")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.workgroupPermValidation
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: { click: _vm.createProposedChanges },
                          },
                          [_vm._v("Propose Change")]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row",
              class: { "margin-above": _vm.areThereAnyAppliedFilters },
            },
            [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _vm.areThereAnyAppliedFilters
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-default btn-sm color-black",
                          attrs: {
                            href: _vm.getWindowLocation(),
                            role: "button",
                            title: "Clear all filters",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-filter",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("em", [_vm._v("Clear all filters")]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fas fa-times",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.appliedFiltersData, function (value, key) {
                    return _c(
                      "a",
                      {
                        key: key,
                        staticClass:
                          "btn btn-default btn-sm margin-right-small color-black",
                        attrs: {
                          href: _vm.removeParamFromUrl(key, value.value),
                          role: "button",
                          title: `Remove ${key} filter`,
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-filter",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("em", [_vm._v(_vm._s(key))]),
                        _vm._v(
                          ": " +
                            _vm._s(value.title) +
                            "\n                        "
                        ),
                        _c("i", {
                          staticClass: "fa fa-times",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-body" },
          [
            _c("div", { staticClass: "margin-below" }, [
              _c("div", { staticClass: "btn-group" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    class: {
                      "bold-font btn-primary pointer-events-none":
                        _vm.showOpenIssues,
                    },
                    attrs: {
                      href: _vm.generateUrl("isopen", true),
                      role: "button",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        Open\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    class: {
                      "bold-font btn-danger pointer-events-none":
                        !_vm.showOpenIssues,
                    },
                    attrs: {
                      href: _vm.generateUrl("isopen", false),
                      role: "button",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        Closed\n                    "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "margin-above" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(!_vm.isLoading ? _vm.getShowingText() : "​") +
                    "\n                    "
                ),
                _c("hr", { staticClass: "no-margin" }),
              ]),
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table table-layout-fixed" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(
                      "\n                        Issue name\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "col", attrs: { scope: "col" } }, [
                    _vm._v(
                      "\n                        Description\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.itemId
                    ? _c("th", { attrs: { scope: "col" } }, [
                        _vm._v(
                          "\n                        Item\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "very-small-col", attrs: { scope: "col" } },
                    [
                      _c("sorting-arrows", {
                        attrs: {
                          text: "Created",
                          ordering: _vm.ordering,
                          "asc-param": "-created",
                          "desc-param": "created",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "very-small-col", attrs: { scope: "col" } },
                    [
                      _c("sorting-arrows", {
                        attrs: {
                          text: "Updated",
                          ordering: _vm.ordering,
                          "asc-param": "-bumped_date",
                          "desc-param": "bumped_date",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
              ]),
              _vm._v(" "),
              _vm.itemIssues.length > 0
                ? _c(
                    "tbody",
                    _vm._l(_vm.itemIssues, function (issue) {
                      return _c("tr", { key: issue.id }, [
                        _c("td", [
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "no-link-decoration",
                                staticStyle: {
                                  "white-space": "normal",
                                  "overflow-wrap": "break-word",
                                },
                                attrs: { href: issue.url },
                              },
                              [
                                _c("open-close-issues", {
                                  attrs: {
                                    "is-open": issue.isopen,
                                    "is-alert": false,
                                    "include-text": false,
                                  },
                                }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(issue.name) +
                                    " "
                                ),
                                _c("span", { staticClass: "text-muted" }, [
                                  _c("em", [_vm._v("#" + _vm._s(issue.pk))]),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "margin-left" }, [
                              _c("small", [
                                _c("i", {
                                  staticClass: "fa fa-fw fa-user text-muted",
                                  attrs: {
                                    "aria-hidden": "true",
                                    title: "Submitter",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.generateUrl(
                                        "submitter",
                                        issue.submitter_id
                                      ),
                                      title: "Filter by submitter",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(issue.submitter_display_name) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            !_vm.workgroupId && issue.workgroup_id
                              ? _c("div", { staticClass: "margin-left" }, [
                                  _c("small", [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-fw fa-users text-muted",
                                      attrs: {
                                        "aria-hidden": "true",
                                        title: "Workgroup",
                                      },
                                    }),
                                    _vm._v(" "),
                                    issue.workgroup_id
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.generateUrl(
                                                "workgroup",
                                                issue.workgroup_id
                                              ),
                                              title: "Filter by Workgroup",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(issue.workgroup_name) +
                                                "\n                                    "
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(issue.workgroup_name) +
                                              "\n                                    "
                                          ),
                                        ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            issue.stewardship_organisation_name
                              ? _c("div", { staticClass: "margin-left" }, [
                                  _c("small", [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-fw fa-sitemap text-muted",
                                      attrs: {
                                        "aria-hidden": "true",
                                        title: "Stewardship Organisation",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.generateUrl(
                                            "stewardship_organisation",
                                            issue.stewardship_organisation_uuid
                                          ),
                                          title:
                                            "Filter by Stewardship Organisation",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              issue.stewardship_organisation_name
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            issue.label_names.length
                              ? _c(
                                  "div",
                                  { staticClass: "label-container" },
                                  _vm._l(issue.label_names, function (label) {
                                    return _c(
                                      "div",
                                      {
                                        key: label.pk,
                                        staticClass: "label-container",
                                      },
                                      [
                                        _c("issue-label", {
                                          attrs: {
                                            label: label.label,
                                            filterable: true,
                                            size: "xs",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          issue.description
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "white-space": "normal",
                                    "overflow-wrap": "break-word",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.descriptionCharacterLimit >
                                          issue.description.length
                                          ? issue.description
                                          : issue.description.substring(
                                              0,
                                              _vm.descriptionCharacterLimit
                                            ) + " ..."
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _c("div", [
                                _vm._v(
                                  "\n                            -\n                        "
                                ),
                              ]),
                        ]),
                        _vm._v(" "),
                        !_vm.itemId
                          ? _c("td", [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(issue.item_statuses_html),
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "small",
                            {
                              attrs: {
                                title:
                                  "Created on " +
                                  issue.created.substring(0, 10),
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.humanizedTime(issue.created)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          issue.bumped_date
                            ? _c(
                                "small",
                                {
                                  attrs: {
                                    title:
                                      "Last updated on " +
                                      issue.bumped_date.substring(0, 10),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.humanizedTime(issue.bumped_date)
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _c("small", [
                                _vm._v(
                                  "\n                            -\n                        "
                                ),
                              ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          issue.number_of_comments > 0
                            ? _c(
                                "a",
                                {
                                  staticClass: "no-link-decoration",
                                  attrs: {
                                    title:
                                      issue.number_of_comments + " Comments",
                                    href: `${issue.url}#end_comment`,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-comment-o",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(issue.number_of_comments) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _c("div", [
                                _vm._v(
                                  "\n                            -\n                        "
                                ),
                              ]),
                        ]),
                      ])
                    }),
                    0
                  )
                : _c("tbody", [
                    !_vm.isLoading
                      ? _c("tr", [
                          _c("td", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.getNoIssuesMessage()) +
                                "\n                    "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
            ]),
            _vm._v(" "),
            _vm.isLoading ? _c("loading") : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _vm.totalIssues > 25
                  ? _c("pagination", {
                      attrs: { "total-page": _vm.totalPage, size: "sm" },
                      on: { change: (pageIndex) => _vm.changePage(pageIndex) },
                      model: {
                        value: _vm.currentPage,
                        callback: function ($$v) {
                          _vm.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      { staticClass: "very-centered-small-col", attrs: { scope: "col" } },
      [
        _c("i", {
          staticClass: "fa fa-comment-o",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }